import { render, staticRenderFns } from "./items-dropdown-filter.vue?vue&type=template&id=938305fe&scoped=true&"
import script from "./items-dropdown-filter.vue?vue&type=script&lang=js&"
export * from "./items-dropdown-filter.vue?vue&type=script&lang=js&"
import style0 from "./items-dropdown-filter.vue?vue&type=style&index=0&id=938305fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938305fe",
  null
  
)

export default component.exports